<template>
  <div :class="classObj" class="app-wrapper">
    <div
      v-if="device === 'mobile' && sidebar.opened"
      class="drawer-bg"
      @click="handleClickOutside"
    />
    <sidebar class="sidebar-container" />
    <div class="main-container">
      <div :class="{ 'fixed-header': fixedHeader }">
        <navbar @togglePasswordDialog="togglePasswordDialog" />
      </div>
      <app-main />

      <footer
        class="bg-white padding-sm text-center flex align-center justify-center"
      >
        <span class="margin-right">
         {{siteData.filingNamber}}
        </span>
        <a
        v-if="siteData.isShowQQ"
          href="tencent://message/?uin=2851711831&amp;Site=http://www.tofba.com/&amp;Menu=yes"
          target="_blank"
          title="QQ"
        >
          <img src="../assets/images/site_qq.jpg" alt="QQ">
        </a>
      </footer>
    </div>

    <el-backtop target=".main-container" />
    <el-dialog title="修改密码" :visible.sync="passwordFormDialog" width="34%" :show-close="!showclose" :close-on-press-escape="false" :close-on-click-modal="false">
      <el-form
        ref="passwordForm"
        :model="passwordForm"
        label-width="80px"
        :rules="passwordFormRules"
      >
        <el-form-item prop="loginedPassWord">
          <div slot="label">旧密码</div>
          <el-input
            v-model="passwordForm.loginedPassWord"
            show-password
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item prop="passWord">
          <div slot="label">新密码</div>
          <el-input
            v-model="passwordForm.passWord"
            show-password
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item prop="confirmPassWord">
          <div slot="label">确认密码</div>
          <el-input
            v-model="passwordForm.confirmPassWord"
            show-password
            autocomplete="off"
          />
        </el-form-item>
        <div v-if="showTips" class="text-red">
          温馨提示：您的密码过于简单需要重置，2022年3月1日起需要先修改才能正常使用系统。
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          size="mini"
          @click="cancelChangePassword"
        >取 消</el-button>
        <el-button
          type="primary"
          size="mini"
          @click="enterChangePassword"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import { updatePassword } from '@/api/user'
import {
		mapGetters
	} from 'vuex'
export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  mixins: [ResizeMixin],
  data() {
    return {
      passwordFormDialog: false,
      // showTips: false,
      passwordForm: {
        loginedPassWord: '',
        passWord: '',
        confirmPassWord: ''
      },
    }
  },
  computed: {
    ...mapGetters(['siteData']),
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    fixedHeader() {
      return this.$store.state.settings.fixedHeader
    },
    showTips() {
      const isSimple = sessionStorage.getItem('isSimple')

      return !!isSimple
    },
    showclose() {
      return new Date().getTime() - 1646064001000 > 0
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    },
    passwordFormRules(){
      const passwordFormRules = {
        loginedPassWord: [
          { required: true, message: '请填写旧密码', trigger: 'blur' }

        ],
        passWord: [
          { required: true, message: '请填写新密码', trigger: 'blur' },
          { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,11}$/, message: '密码必须为字母+数字 大于和等于8位和小于12位的组合' }

        ],
        confirmPassWord: [
          { required: true, message: '请填写新密码', trigger: 'blur' },
          { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,11}$/, message: '密码必须为字母+数字 大于和等于8位和小于12位的组合' }
        ]
      }
      return passwordFormRules
    }
  },
  mounted() {
    if (sessionStorage.getItem('isSimple')) {
      this.togglePasswordDialog()
    }
    console.log(this.siteData.filingNamber)
  },

  methods: {
    cancelChangePassword() {
      if (this.showTips && this.showclose) {
        this.$store.dispatch('user/logout')
        this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      } else {
        console.log('111 :>> ', 111)
        this.togglePasswordDialog()
      // this.passwordFormDialog = null
      // this.passwordFormDialog = false
      }
    },
    togglePasswordDialog() {
      this.passwordFormDialog = !this.passwordFormDialog
    },
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    },
    // changePassword() {
    //   this.$store.dispatch('app/togglePasswordDialog')
    // },
    enterChangePassword() {
      this.$refs.passwordForm.validate(valid => {
        if (valid) {
          console.log('submit')

          if (
            this.passwordForm.passWord !== this.passwordForm.confirmPassWord
          ) {
            this.$message.error('新密码不一致')
          } else {
            this.updatePassword()
          }

          return true
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async updatePassword() {
      // TODO 请求修改密码接口
      const { loginedPassWord, passWord } = this.passwordForm
      const returndata = await updatePassword({
        oldPassWord: loginedPassWord,
        newPassWord: passWord
      })
      console.log('returndata', returndata)

      if (returndata.data) {
        this.$message.success('修改成功，请重新登录')
        this.togglePasswordDialog()
        await this.$store.dispatch('user/logout')
        this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      } else {
        this.$message.error(returndata.mass)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
@import '~@/styles/variables.scss';

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}
.main-container {
  overflow-y: auto;
  height: 100%;
}
footer {
  border-top: 1px solid #ff7e00;
}
</style>
